<template>
	<div>
		<md-toolbar md-elevation="1" class="md-dense my-toolbar">
			<h3 class="md-subheading">{{forum.name}}</h3>
		</md-toolbar>

		<ul class="pankuzu">
			<li><router-link to="/" ><md-icon style="color:inherit;">home</md-icon></router-link></li>
			<li><router-link :to="`/${forum.slug}/`" >{{forum.name}}</router-link></li>
			<li>{{topic.title}}</li>
		</ul>

		<CreateComment ref="create_comment_component" v-show="!loading" />

		<div class="comment-list" style="border:none;" v-show="topic.id">
			<div class="item">
				<div class="head head-first">
					<h2 class="title">{{topic.title}}</h2>
				</div>
				<div class="head">
					<span v-if="topic.user_name">{{topic.user_name}}</span>
					<span v-else>匿名</span>
					<span class="date">{{dateFormat(topic.regist_dt)}}</span>
				</div>
				<div class="body" v-html="commentFormat(topic.body)"></div>
			</div>
		</div>

		<div style="text-align:right;padding: 1rem 0;">
			<md-button class="md-raised" @click="$refs.create_comment_component.openDialog('')"><md-icon>edit</md-icon>コメント</md-button>
			<md-button class="md-raised" @click="doReflesh()" :disabled="reflesh_disabled"><md-icon>refresh</md-icon>更新</md-button>
		</div>

		<div class="comment-list">
			<div class="item" v-for="(comment, index) in comments" v-bind:key="comment.id" :id="`cm${comment.num}`">
				<div class="head">
					<a href="javascript:;" @click="$refs.create_comment_component.openDialog('>>'+comment.num+' ')" class="num">#{{comment.num}}</a>
					<span v-if="comment.user_name">{{comment.user_name}}</span>
					<span v-else>匿名</span>
					<span class="date">{{dateFormat(comment.regist_dt)}}</span>
					<span v-if="index==0" class="latest">[最新コメント]</span>
				</div>
				<div class="body" v-html="commentFormat(comment.body)"></div>
			</div>
		</div>

		<div v-show="loading" style="text-align:center;padding:1rem;">
			<md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CreateComment from '@/components/CreateComment.vue';
export default {
	name: 'CommentList',
	components: {
		CreateComment
	},
	data: ()=>{
		return {
			loading : false,
			reflesh_disabled : false,
			forum : {},
			topic : {
				// id : 1, title : "気軽に質問☆"
			},
			comments : [
				// { num : 1, body : "ぽこ" },
			],
		}
	},
	props: {},
	methods : {
		doReflesh : function(){
			this.reflesh_disabled = true;
			let self = this;
			this.getComments(function(){
				setTimeout(()=>{
					self.reflesh_disabled = false;
				}, 2000);
			});
		},
		// コメント一覧取得.
		getComments : function( cb=null ){ 
			// console.log(this);
			this.loading = true;
			this.comments = [];
			axios.get('https://9kzgu3ix6l.execute-api.ap-northeast-1.amazonaws.com/main/comment?topic_id='+this.$route.params.topic_id)
				.then(response => {
					// console.log(response.data)
					// console.log(response.status)
					this.loading = false;
					if ( response.status == 200 ) {
						// 通信成功.
						// // 配列を結合する.
						// this.comments = this.comments.concat(response.data);
						this.comments = response.data;
						if (cb) cb();
					}
				});
		},
		getForum : function(){
			this.loading = true;
			axios.get('https://9kzgu3ix6l.execute-api.ap-northeast-1.amazonaws.com/main/forum?slug='+this.$route.params.forum_slug)
				.then(response => {
					// console.log(response.data)
					// console.log(response.status)
					this.loading = false;
					if ( response.status == 200 ) {
						// 通信成功.
						if ( response.data && 0 < response.data.length ) {
							this.forum = response.data[0];
						}
					}
				})
				.catch(()=>{
					this.loading = false;
				});
		},
		// スレッド個別取得.
		getTopic : function(){
			// return;
			this.loading = true;
			axios.get('https://9kzgu3ix6l.execute-api.ap-northeast-1.amazonaws.com/main/topic?id='+this.$route.params.topic_id)
				.then(response => {
					// console.log(response.data)
					// console.log(response.status)
					this.loading = false;
					if ( response.status == 200 ) {
						// 通信成功.
						if ( response.data && 0 < response.data.length ) {
							this.topic = response.data[0];
							// タイトル変える.
							this.global_set_title(`${this.topic.title}`);
						}
					}
				});
		},
		dateFormat : function ( date, format=null ) {
			// if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
			if (!format) format = 'YYYY/MM/DD hh:mm';
			if ( !date ) date = Date.now();
			if ( typeof date == "number" || typeof date == "string" ) {
				date = new Date(date);
			}
			format = format.replace(/YYYY/g, date.getFullYear());
			format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
			format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
			format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
			format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
			format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
			if (format.match(/S/g)) {
				var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
				var length = format.match(/S/g).length;
				for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
			}
			return format;
		},
		commentFormat : function ( text ) {
			if (!text) return text;
			var ret = text.replace(/[&'`"<>]/g, function(match) {
				return {
				'&': '&amp;',
				"'": '&#x27;',
				'`': '&#x60;',
				'"': '&quot;',
				'<': '&lt;',
				'>': '&gt;',
				}[match]
			});
			// nl2br.
			ret = ret.replace(/\n/g, "<br/>");
			//TODO: レス番号指定をリンクに.
			ret = ret.replace(/&gt;&gt;([0-9]+)/g, '<a href="javascript:;" onclick="toHashScroll(\'#cm$1\')">&gt;&gt;$1</a>');
			// urlをリンクに.
			ret = ret.replace(/(https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)/g, '<a href="$1" target="_blank" rel="nofollow">$1</a>')
			return ret;
		},
	},
	created : function(){
		this.getForum();
		this.getTopic();
		this.getComments();
		// どこから飛んでくるかわからないけどイベント待ち受ける.
		// 2重登録を防ぐためoffしてから.
		this.$root.$off("reload-CommentList").$on("reload-CommentList", this.getComments);
	},
}
// hash位置までスクロール...
window.toHashScroll = function ( selector ) {
	const headH = 0;
    const interval = 10;               //スクロール処理を繰り返す間隔
    const divisor = 8;                  //近づく割合（数値が大きいほどゆっくり近く）
    const range = (divisor / 2) + 1;    //どこまで近づけば処理を終了するか(無限ループにならないように divisor から算出)
	let toY;
	let nowY = window.pageYOffset;                       //現在のスクロール値
	const target = document.querySelector(selector);         //リンク先の要素（ターゲット）取得
	target.backgroundColor="red";
	const targetRect = target.getBoundingClientRect();   //ターゲットの座標取得
	const targetY = targetRect.top + nowY - headH;        //現在のスクロール値 & ヘッダーの高さを踏まえた座標
	//スクロール終了まで繰り返す処理
	(function doScroll() {
		toY = nowY + Math.round((targetY - nowY) / divisor);  //次に移動する場所（近く割合は除数による。）
		window.scrollTo(0, toY);                              //スクロールさせる
		nowY = toY;                                           //nowY更新

		if (document.body.clientHeight - window.innerHeight < toY) {
			//最下部にスクロールしても対象まで届かない場合は下限までスクロールして強制終了
			window.scrollTo(0, document.body.clientHeight);
			return;
		}
		if (toY >= targetY + range || toY <= targetY - range) {
			//+-rangeの範囲内へ近くまで繰り返す
			window.setTimeout(doScroll, interval);
		} else {
			//+-range の範囲内にくれば正確な値へ移動して終了。
			window.scrollTo(0, targetY);
		}
	})();
}
</script>

<style scoped lang="scss">
.comment-list {
	text-align: left;
	border-top: 1px solid rgba($color: #000000, $alpha: 0.12);
	.item {
		.head {
			position: relative;
			margin: 0;
			// background-color: #efefef;
			background-color: #fff;
			font-size: 0.8rem;
			padding: 0.3rem 0.5rem;
			.num {
				font-weight: bold;
				margin-right: 0.5rem;
				font-size: 1rem;
			}
			.title {
				font-size: 1rem;
				margin: 0;
			}
			.date {
				margin-left: 0.5rem;
				color: #888;
			}
			.latest {
				margin-left: 0.5rem;
				color: red;
			}
		}
		.head-first {
			background-color: transparent;
			padding: 1rem 0.5rem;
			border-bottom: 1px solid rgba($color: #000000, $alpha: 0.12);
		}
		.body {
			padding: 0.5rem 0.5rem 1.2rem 0.5rem;
			background-color: #ffffff;
			font-size: 1rem;
		}
		border-bottom: 1px solid rgba($color: #000000, $alpha: 0.12);
	}
	.title {
		font-weight: bold;
		margin-bottom: 6px;
	}
}
</style>
